var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a_1_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-back-15",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35813986,0.4 C9.35813986,0 8.75813986,-0.1 8.55813986,0.1 L5.55813986,2.7 C5.45813986,2.8 5.45813986,2.8 5.45813986,2.8 C5.25813986,3 5.35813986,3.2 5.45813986,3.4 L8.45813986,5.9 C8.85813986,6.2 9.35813986,6 9.35813986,5.6 L9.35813986,4 C11.2581399,4 13.0581399,4.8 14.3581399,6.1 C17.1581399,8.9 17.0581399,13.3 14.3581399,16 C11.6581399,18.7 7.15813986,18.7 4.45813986,15.9 C1.65813986,13.1 1.75813986,8.7 4.45813986,6 L3.05813986,4.6 C-0.541860141,8 -0.541860141,13.7 2.95813986,17.3 C6.45813986,20.9 12.1581399,21 15.6581399,17.5 C19.2581399,14 19.2581399,8.3 15.7581399,4.7 C14.0581399,3 11.7581399,2 9.35813986,2 L9.35813986,0.4 Z M7.44550781,10 L6.74550781,10.2 L6.54550781,9.4 L7.74550781,9 L8.34550781,9 L8.34550781,13.2 L7.44550781,13.2 C7.44550781,13.2 7.44550781,9.9 7.44550781,10 Z M8.96981847,12.7 L9.56981847,12 C9.86981847,12.3 10.1698185,12.5 10.5698185,12.5 C10.9698185,12.5 11.2698185,12.3 11.2698185,11.9 L11.2698185,11.9 C11.2698185,11.5 10.9698185,11.3 10.5698185,11.3 C10.3698185,11.3 10.0698185,11.4 9.86981847,11.5 L9.36981847,11.1 L9.46981847,9 L12.0698185,9 L12.0698185,9.9 L10.2698185,9.9 L10.2698185,10.6 C10.4698185,10.5 10.6698185,10.5 10.8698185,10.5 C11.6698185,10.5 12.3698185,10.9 12.3698185,11.8 L12.3698185,11.8 C12.3698185,12.7 11.7698185,13.3 10.7698185,13.3 C10.0698185,13.3 9.56981847,13.1 8.96981847,12.7 Z",
    id: "a_1_-back-15",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack15);
export default __webpack_public_path__ + "static/media/back-15.de85c25f.svg";
export { ForwardRef as ReactComponent };